<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
	<div class="row">
	  <div class="col-12"></div>
	  <div class="col-12">
		<div class="card">
		  <div class="card-content">
			<div class="card-body">
			  <!-- ngx-datatable-filter -->
			  <fieldset class="form-group">
				<div class="row align-items-end mt-0 pagination-body">
				  <div class="col-12 col-sm-12 col-md-3 col-lg-3 mb-2">
					<ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="40"
					[footerHeight]="40" rowHeight="auto" [limit]="limitRef" [rows]="rows" [externalPaging]="true"
					[count]="page.totalPages" [offset]="page.pageNumber" (page)="pageChangeData($event)"></ngx-datatable>
				  </div>
				  
				  <div class="col-12 col-sm-12 col-md-9 col-lg-9 mt-2 mb-1">
					<div class="row-flex">
					  <div class="col-flex-2 mb-1 position-relative">
						<input id="ngx-filter-ref"
						  class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
						  type="text" (keydown.enter)="filter(searchVal)" placeholder="Search" #name [(ngModel)]="searchVal"  />
						<button class="btn search-btn glow position-absolute" (click)="filter(searchVal)">
						  <i class="ft-search text-white cursor-pointer"></i>
						</button>
					  </div>
					  <div class="col-flex-2 mb-1">
						<button class="btn btn-primary btn-block users-list-clear glow mb-0" >
						  Reset
						  <i class="ft-filter text-white cursor-pointer"></i>
						</button>
					  </div>
					</div>
				  </div>
				  <!-- <div class="col-12">
					<button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Tags Guideline</button>
					</div> -->
				</div>
			  </fieldset>
			  <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="50"
				[footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows" [scrollbarH]="true"
				[columns]="columns" [externalPaging]="true" [count]="page.totalPages" [offset]="page.offset"
				(page)="pageChangeData($event)">
				<ngx-datatable-column name="Title" prop="title" [width]="60">
				  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
					<div class="d-flex align-items-center">
					  <div class="cell-line-height cursor-pointer">
						<p class="font-medium-1 line-height-1 mb-0">
						  {{ row?.chapters[0]?.topics[0]?.name}}
						</p>
					  </div>
					</div>
				  </ng-template>
				</ngx-datatable-column>
				
				<ngx-datatable-column name="Actions" [width]="50">
				  <ng-template let-row="row" ngx-datatable-cell-template>
					<i class="ft-settings text-primary cursor-pointer mr-2" (click)="openContent(myModalFaqContent,row)" placement="right" ngbTooltip="Click to Open Faq details"></i>
					<!-- <i *ngIf="user_role.roles =='admin'" class="ft-trash-2 cursor-pointer danger"
					  (click)="ConfirmColor(row._id)"></i> -->
				  </ng-template>
				</ngx-datatable-column>
			  </ngx-datatable>
			  <!-- ngx-datatable-filter -->
			</div>
		  </div>
		</div>
	  </div>
	</div>
  </section>
  <!--/ Filter Datatables -->
  <div class="d-flex justify-content-between align-items-center">
	<ngx-spinner></ngx-spinner>
  </div>

  
<!------------- Content Popup --------------------------------------->
<div>
	<ng-template #myModalFaqContent>
	  <div class="modal-header">
		<h4 class="modal-title">Faq Content</h4>
		<button type="button" class="close" aria-label="Close" (click)="modalService.dismissAll()">
		  <span aria-hidden="true">&times;</span>
		</button>
	  </div>
	  <div class="modal-body">
		<div class="app-section" *ngFor="let app of app_data">
			<div class="col d-flex align-items-center">
			  <h4  class="app-title-h4">
				{{app?.app?.title}}
			  </h4> 
			</div>
			<div *ngIf="app?.app?.type === 'image'">
			  <!-- Display image content -->
			  <img width="100%" [src]="s3MediaUrl+app?.app?.content" alt="Image" />
			</div>
			<div *ngIf="app?.app?.type === 'video'&&!app.isurl_link">
			  <!-- Display video content -->
			  <video width="100%" [src]="s3MediaUrl+app?.app?.content" controls></video>
			</div>
			<div *ngIf="app?.app?.type === 'video'&&app.isurl_link ">
			  <!-- Display video content -->
			  <div [innerHTML]="this.sanitizedUrl"></div>
			   <!-- {{formatHtmlapp?.app?.url_link }} -->
			</div>
			<div *ngIf="app?.app?.type === 'text'">
			  <!-- Display markdown text content -->
			  <div [innerHTML]="app?.app?.content"></div>
			</div>
			<!-- <div [hidden]="isReadMode" *ngIf="user.roles === 'admin'">
			  <i [ngClass]="isConnected(app?.app?._id)?'fa fa-x cursor':'fa fa-link cursor'" title="Disconnect app"
			  (click)="connectDisconnect(app?.app?._id)"></i>
			  <i class="fa fa-edit cursor ml-2" data-toggle="modal" data-target="#app-model" (click)="editApp(app)"></i>
			  </div> -->
		
			  <!-- <div class="row p-2" *ngIf=" user.roles !=='student'">
				<div class="btn btn-outline-primary ml-2" *ngFor="let resource of app.resources">
				  <a [href]="s3MediaUrl+resource.documents" target="_blank">{{resource.content}}</a>
				  <i class="fa fa-x cursor danger font-large float-right" (click)="resourceDelete(app?.app?._id,resource._id)"></i>
				</div> -->
				<!-- <div class="col-xl-3 col-lg-6 col-12" *ngFor="let resource of app.resources">
				  <div class="card">
					<div class="card-content">
					  <div class="card-body">
						<div class="media">
						  <div class="media-body text-left">
							<h3 class="mb-1 danger">{{resource}}</h3>
							<span></span>
						  </div>
						  <div class="media-right align-self-center">
							<i class="fa fa-x cursor danger font-large-1 float-right"></i>
						  </div>
						</div>
					  </div>
					</div>
				  </div>
				</div> -->
			  <!-- </div> -->
		
		  </div>
	  </div>
	  <div class="modal-footer">
		<!-- <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Close</button> -->
		<!-- <button type="button" class="btn btn-primary" (click)="projectAssign()">Submit</button> -->
	  </div>
	</ng-template>
</div>
  
  